//Limitless imports
import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { getGraphQLClient } from "../clients/GraphQLClient";
import { getEncodingPayload } from "./queries/MessageClassificationMutations";
export const classifyMessage = (message, classificationPayload, callback) => {
  const graphQLClient = getGraphQLClient();
  graphQLClient.mutate(getEncodingPayload(classificationPayload, message)).then(response => {
    const message = response.data.encodeMessage;
    callback(message);
  }).catch(error => {
    handleSecureAjaxError(error, "MessageClassificationActions flagMessage");
    callback({
      hasError: true,
      error
    });
  });
};